// extracted by css-extract-rspack-plugin
export default {"howItWorksContainer":"nl6oRiEpY7jrPpuMRgZu","howItWorksContent":"wk8YlqNHwlf5ADFRiB1Q","cardContainer":"GiXPoXJDz8OHRtsDm4gw","companyLogo":"f7Uyu4KHO1pNOOPZXcU3"};